import React, { memo, useState } from 'react'
import { Button } from 'primereact/button'

import { Header } from '../../../lib/header'
import { BarChart } from '../../../lib/bar-chart'
import { IDetailedChargingSession } from '../../../common/redux/api/web-api'
import useText from '../../../common/hooks/useText'

import { StatisticsHelpDialog } from './dialogs/statistics-help-dialog'

export type UserAppStatisticsTotalConsumptionWidgetProps = {
    download: () => void
    downloadLoading: boolean
    reloadChart: (type: string) => void
    data: Array<IDetailedChargingSession>
    useMonth: boolean
}

export const UserAppStatisticsTotalConsumptionWidget = memo(function UserAppStatisticsTotalConsumptionWidget({
    download,
    downloadLoading,
    reloadChart,
    data,
    useMonth,
}: UserAppStatisticsTotalConsumptionWidgetProps): React.ReactElement {
    const text = useText()
    const [showInfo, setShowInfo] = useState(false)

    return (
        <div className="row">
            <div className="col-xs-12">
                <div className="flex align-items-center justify-content-center gap-1">
                    <Header code="lblTotalConsumption" dataTestId="total-consumtion-header" />
                    <div className="flex gap-2">
                        <Button
                            type="button"
                            size="small"
                            label={text('msgDownloadAsCSV')}
                            icon="pi pi-download"
                            tooltip={text('msgDownloadAsCSV')}
                            tooltipOptions={{ position: 'top' }}
                            loading={downloadLoading}
                            onClick={download}
                            data-testid="download"
                        />
                        <Button
                            type="button"
                            size="small"
                            label={text('btnHelp')}
                            icon="pi pi-question-circle"
                            outlined
                            tooltip={text('btnHelp')}
                            tooltipOptions={{ position: 'top' }}
                            onClick={() => setShowInfo(true)}
                        />
                    </div>
                </div>
                <div className="row flex justify-content-end mt-4">
                    <div>
                        <select className="form-control" onChange={(e) => reloadChart(e.target.value)} required>
                            <option value="currentmonth">{text('msgThisMonthOption')}</option>
                            <option value="lastmonth">{text('msgLastMonthOption')}</option>
                            <option value="currentyear">{text('msgThisYearOption')}</option>
                            <option value="lastyear">{text('msgLastYearOption')}</option>
                        </select>
                    </div>
                </div>
                <BarChart barChartId="dygraphStatistic" data={data} useMonth={useMonth}></BarChart>
            </div>
            <StatisticsHelpDialog visible={showInfo} onHide={() => setShowInfo(false)} />
        </div>
    )
})
